/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { KTSVG, toAbsoluteUrl } from '../../../../../_metronic/helpers'
import { useAuth } from '../../../auth'
import { getResetPasswordKey } from '../../../auth/core/_requests'

export function Overview() {
  const { currentUser } = useAuth()
  const [encoded_id, setEncodedID] = useState(undefined)

  try {
    if(encoded_id == undefined){
      getResetPasswordKey().then((response)=>{
        //console.log(response.data)
        setEncodedID(response.data)
      })
    }
  } catch (error) {
    console.error(error)
  }

  return (
    <>
      <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
        <div className='card-header cursor-pointer'>
          <div className='card-title m-0'>
            <h3 className='fw-bolder m-0'>Profile Details</h3>
          </div>

          <Link to='/home/account/settings' className='btn btn-primary align-self-center'>
            Edit Profile
          </Link>
        </div>

        <div className='card-body p-9'>
          <div className='row mb-7'>
            <label className='col-lg-2 fw-bold text-muted'>ขื่อ</label>

            <div className='col-lg-10'>
              <span className='fw-bolder fs-6 text-dark'>{currentUser?.first_name ?? '-'}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-2 fw-bold text-muted'>นามสกุล</label>

            <div className='col-lg-10 fv-row'>
              <span className='fw-bold fs-6'>{currentUser?.last_name ?? '-'}</span>
            </div>
          </div>

          <div className='row mb-7'>
            <label className='col-lg-2 fw-bold text-muted'>
              email
            </label>

            <div className='col-lg-10 d-flex align-items-center'>
              <span className='fw-bolder fs-6 me-2'>{currentUser?.email ?? '-'}</span>
            </div>
          </div>

          {currentUser && <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed p-6'>
            <KTSVG
              path='icons/duotune/general/gen044.svg'
              className='svg-icon-2tx svg-icon-warning me-4'
            />
            <div className='d-flex flex-stack flex-grow-1'>
              <div className='d-flex align-items-center py-1'>
                <div className='symbol symbol-35px me-2'>
                  <img
                    alt='key'
                    src={toAbsoluteUrl('/media/custom/key.png')}
                    className='d-none d-lg-inline w-50px theme-light-show'
                  />
                </div>

                <div className='d-flex flex-column align-items-start justify-content-center'>
                  <div className='fw-bold'>
                    <h4 className='text-gray-800 fw-bolder'>ต้องการแก้เปลี่ยนรหัสผ่านใหม่?</h4>
                    <div className='fs-6 text-gray-600'>
                      <Link className='fw-bolder' to={'/home/password_reset?reset='+encoded_id}>
                        {' '}
                        คลิกเพื่อเปลี่ยนรหัสผ่านในการเข้าระบบใหม่
                      </Link>
                      .
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        </div>
      </div>
    </>
  )
}
